<template>
  <div class="course-container">
    <!-- 背景图区域 -->
    <div class="bg-wrapper"></div>

    <!-- 课程卡片区域 -->
    <div class="course-list">
      <div
        v-for="(item, index) in courseList"
        :key="index"
        class="course-item"
        @mouseenter="handleMouseEnter(index)"
        @mouseleave="handleMouseLeave(index)"
        @click="handleCardClick(item)"
      >
        <!-- 课程图标容器 -->
        <div
          class="course-icon-wrapper"
          :style="{ backgroundImage: `url(${item.isHover ? hoverBg : normalBg})` }"
        >
          <img
            :src="item.iconUrl"
            alt="课程图标"
            class="course-icon"
          >
          <div class="course-name">{{ item.title }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  // 导入背景图片
  import normalBgImg from '@/assets/normal-bg.png';
  import hoverBgImg from '@/assets/hover-bg.png';

  export default {
    name: 'CourseCard',
    data() {
      return {
        // 使用导入的图片资源
        normalBg: normalBgImg,
        hoverBg: hoverBgImg,
        courseList: [
        ]
      }
    },
    created() {
      this.fetchCourseList()
    },
    methods: {
      fetchCourseList() {
        axios.get('/api/lessons/page').then(res => {
          if (res.data) {
            this.courseList = res.data.list.map(item => ({
              ...item,
              isHover: false,
              iconUrl: item.iconUrl
            }))
          }
        })
      },
      handleMouseEnter(index) {
        this.courseList[index].isHover = true;
      },
      handleMouseLeave(index) {
        this.courseList[index].isHover = false;
      },
      handleCardClick(item) {
        if (item.flag === 1) {
          this.$router.push({ path: '/chapter', query: { id: item.lessonsId } })
        } else {
          this.$message.warning('该课程暂未开放')
        }
      }
    }
  }
</script>

<style scoped>
  /* 背景图固定、填满屏幕 */
  .bg-wrapper {
    position: fixed;
    top: 0; left: 0;
    width: 100vw;
    height: 100vh;
    background: url('~@/assets/bg-second.png') no-repeat center center;
    background-size: cover;
    z-index: -1;
  }

  /* 页面容器：允许内容滚动 */
  .course-container {
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    padding-top: 42vh; /* 卡片区域推至页面高度 72% */
    padding-bottom: 40px; /* 留出底部空间 */
  }

  /* 卡片列表：不再固定定位，跟随内容 */
  .course-list {
    display: grid;
    gap: 14px 16px;
    padding: 0 10px;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  /* 默认最多 5 列 */
  @media (min-width: 1200px) {
    .course-list {
      grid-template-columns: repeat(5, 1fr);
    }
  }

  /* 中等屏幕 4 列 */
  @media (min-width: 992px) and (max-width: 1199px) {
    .course-list {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  /* 平板 3 列 */
  @media (min-width: 768px) and (max-width: 991px) {
    .course-list {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  /* 手机 2 列 */
  @media (max-width: 767px) {
    .course-list {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* 卡片样式 */
  .course-item {
    width: 100%;
    aspect-ratio: 200 / 176;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  /* 卡片背景框 */
  .course-icon-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    background-size: cover;
    background-position: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .course-item:hover .course-icon-wrapper {
    transform: translateY(-4px);
  }

  /* 图标缩小 */
  .course-icon {
    width: auto;
    object-fit: contain;
  }

  /* 标题 */
  .course-name {
    margin-top: 6px;
    font-size: 16px;
    font-weight: 600;
    color: #202647;
    text-align: center;
    padding: 0 6px;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/sy.vue